<nav class="navbar navbar-expand-lg  user-select-none navbar-dark px-5 fixed-top" style="z-index: 9999 !important; background-color: rgba(0, 0, 0, 0.65) !important;">
  <a class="navbar-brand mt-2" href="#">
    <img width="200" src="../../../../../assets/brand.svg" alt="">
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01" aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse justify-content-center navbar-collapse mt-2" id="navbarColor01" style="font-size: 15px; font-weight: 400;">
    <ul class="navbar-nav mr-4 font-brand-secondary">
      <li class="nav-item active mx-5">
        <a class="nav-link" [routerLink]="['/inicio']" [fragment]="'header'">INICIO <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item active mx-5">
        <a class="nav-link" [routerLink]="['/inicio']" [fragment]="'services'">SERVICIOS</a>
      </li>
      <li class="nav-item active mx-5">
        <a class="nav-link" [routerLink]="['/inicio']" [fragment]="'projects'">PROYECTOS REALIZADOS</a>
      </li>
    </ul>
    <a class="btn btn-lg btn-brand px-5" type="submit" [routerLink]="['/inicio']" [fragment]="'contact'" style="font-size: 15px; font-weight: 400;">CONTACTO</a>
  </div>
</nav>